export const DEPARTMENT_KEYS: Record<string, string> = {
    Technology: 'rnd',
    Product: 'product',
    BI: 'bi',
    Design: 'design',
    Marketing: 'corporate_marketing',
    'Marketplace Business Operations': 'marketplace_business_ops',
    'Customer Journey': 'customer_support',
    'G&A': 'gna',
    Finance: 'finance',
    Sales: 'sales',
    IT: 'it',
};
